import React, { useEffect, useState } from "react";

const Loader = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleLoadingEvent = (e) => {
      setLoading(e.detail);  // Atualiza o estado do loader com o valor do evento
    };

    // Escuta o evento global de carregamento
    window.addEventListener("setLoading", handleLoadingEvent);

    // Limpeza do evento ao desmontar o componente
    return () => {
      window.removeEventListener("setLoading", handleLoadingEvent);
    };
  }, []);

  if (!loading) return null;

  return (
    <div className="loader-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;